"use client";

import { createContext, type ReactNode, useContext } from "react";
import { useImageGenerationSocket } from "./useImageGenerationSocket";

type ImageGenerationSocketContextValue = ReturnType<typeof useImageGenerationSocket>;

const ImageGenerationSocketContext = createContext<ImageGenerationSocketContextValue | null>(null);

export function ImageGenerationSocketProvider({ children }: { children: ReactNode }) {
  const socket = useImageGenerationSocket();

  return (
    <ImageGenerationSocketContext.Provider value={socket}>
      {children}
    </ImageGenerationSocketContext.Provider>
  );
}

export function useGlobalImageGenerationSocket() {
  const context = useContext(ImageGenerationSocketContext);
  if (!context) {
    throw new Error("useGlobalImageGenerationSocket must be used within ImageGenerationSocketProvider");
  }
  return context;
}
